/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import {
     IAccountProfileItem, IAccountProfileViewProps
} from '@msdyn365-commerce-modules/account-management/src/modules/account-profile/./account-profile';

const AccountProfileSection: React.FC<IAccountProfileItem> = ({
    AccountProfileItem,
    heading,
    links,
    description
}) => {

    return (
        <Node {...AccountProfileItem}>
            {heading}
            {description}
            {links}
        </Node>
    );
};

const AccountProfileView: React.FC<IAccountProfileViewProps> = props => {
    const { AccountProfile, accountProfileWrapper, heading, emailSection, nameSection, customerAttributesWrapper, customerAttributesSection } = props;

    return (
        <Module {...AccountProfile}>
            {accountProfileWrapper && (<Node {...accountProfileWrapper}>
                {heading}
                <AccountProfileSection {...emailSection} />
                <AccountProfileSection {...nameSection} />
            </Node>
            )}
            {customerAttributesWrapper && (<Node {...customerAttributesWrapper}>
                {customerAttributesSection}
            </Node>
            )}
        </Module>
    );
};

export default AccountProfileView;
